import { AxiosResponse } from 'axios';
import { http, ServerType } from './http';
import {
    ISoilProfileModel,
    ISoilProfilesRequestModel,
    IReferenceSoilPropertyRequestModel,
    IReferenceEstimationMethodRequestModel,
    IReferenceExtReferenctRequestModel,
    IUserManagementSearchModel,
    IUserManagementSearchRequestModel,
    GetPropertyListResponseModel,
    soilLayerType,
    soilLayerResponseType,
    GetSoilPropertyMethodsType,
    getSoilPropertyMethodsType,
    ISoilRegionResModel,
    ISoilProfilesExtSourceLinkResModel,
    ISoilProfileExtObjectsResModel,
    ISoilProfileAddProfileReqModel,
    ISoilProfileFieldTypeResModel,
    ISoilProfilePlaceNameResModel,
    ISoilProfileGetCountriesReqModel,
    ISoilProfileGetCountriesResModel,
    ISoilProfileGetSoilDetailResModel,
    ISoilProfileGetLayersDetailResModel,
    ISoilProfileMethodsResModel,
    IUserManagementAddUsersRequestModel,
    IUserManagementeEditUsersRequestModel,
    IUserManagementeSendWelcomeEmailrRequestModel,
    IUserManagementeUpdateUserRequestModel,
    IManagementUserInfoResModel,
    ISoilProfileValidateStatusResModel,
    ISoilSearchProfilePointResModel,
    ISoilSearchGetPointByMultiperParamReqModel,
    ISoilProfileCheckThicknessParamReqModel,
    ISoilSearchPropertyResModel,
    ISoilSearchTableViewReqModel,
    ISoilSearchTableViewResModel,
    ISoilSearchAdministrativeAreaResModel,
    ISoilSearchGetProfilePointRequestModel,
    ISoilSearchGetProfilePointByPolygonReqModel,
    ISoilSearchGetProfieTableViewByPolygonReqModel,
    // SECTION: Weather station
    IWeatherStationAdminAreaResModel,
    IFeedbackModel,
    IWeatherStationSupplierPropertiesResModel,
    ISignInUrlResModel,
    ITokenResModel,
    ITokenReqModel,
    IHierarchyDeatails,
    IWeatherStationReqModel,
    IWeatherStationResModel,
    IWeatherChardDataReqModel,
    IWeatherChartDataResModel,
    IWeatherSaveQueryReqModel,
    IWeatherHierarchiesResModel,
    IWeatherStationInfoResModel,
    ISoilSaveQueryReqModel,
    ISoilDeleteQuery,
    ISoilQueriesModel,
    IHierarchy,
    IGetSearchSoilRequestModel,
    IAddEditSoilRequestModel,
    IDeleteSoilRequestModel
} from './requestType';
import {initGetSearchSoilRequestModel,initAddEditSoilRequestModel,initDeleteSoilRequestModel} from './commonConvertReqAndRes';

const getToken = async () => {
    const url = '/api/Home/GetToken';
    const response = await http.get<null, AxiosResponse<string>>(url, null, ServerType.ServerNormal);
    const token = response.data;
    window.localStorage.setItem('accessToken', token);
    console.log(response);
    return response;
};

const getManagerUserToken = async () => {
    const url = '/api/Home/GetTestTokenManagerUser';
    const response = await http.get<null, AxiosResponse<string>>(url, null, ServerType.ServerNormal);
    const token = response.data;
    window.localStorage.setItem('accessToken', token);
    console.log(response);
    return response;
};

const getReaderUserToken = async () => {
    const url = '/api/Home/GetTestTokenReaderUser';
    const response = await http.get<null, AxiosResponse<string>>(url, null, ServerType.ServerNormal);
    const token = response.data;
    window.localStorage.setItem('accessToken', token);
    console.log(response);
    return response;
};


const fetchSoilProfileList = async (data: ISoilProfilesRequestModel) => {
    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.analysis.pageIndex = data.pageIndex;
    requestData.analysis.pageSize = data.pageSize;
    requestData.profile.countryCode = data.countryCode || '';
    requestData.profile.searchString = data.searchString || '';
    requestData.analysis.sortCol = data.sortCol || '';
    requestData.analysis.order = data.order || '';
    requestData.profile.strType = data.strType || '';
    requestData.analysis.strStatus = data.strStatus || '';
    requestData.isAnalysis = false;
    // const response = await http.post<
    // ISoilProfilesRequestModel, AxiosResponse<ISoilProfileModel[]>>(
    //     '/api/SoilAnalysis/GetSoilProfiles',
    //     data,
    // );
    const response = await http.post<IGetSearchSoilRequestModel,any>(
        url,
        requestData,
        ServerType.ServerNormal
    );
    return response.data?.responseMessage?.message;
};

const soilProfileGetMySoilProfileList = async (data: ISoilProfilesRequestModel) => {
    const response = await http.post<
    ISoilProfilesRequestModel, AxiosResponse<ISoilProfileModel[]>>(
        '/api/SoilProfile/GetMySoilProfiles',
        data,
        ServerType.ServerNormal
    );
    return response.data;
};

// by yck
const getSoilLayer = async (param) => {

    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.profile.profileID = param;
    // const res = await http.post<
    //     soilLayerType,AxiosResponse<soilLayerResponseType[]>>(
    //     // '/api/SoilAnalysis/GetSoilLayers',
    //     // {
    //     //     profileID:param
    //     // }
    // );
    const res = await http.post<
        IGetSearchSoilRequestModel,AxiosResponse<any>>(
            url,
            requestData,
            ServerType.ServerNormal
        );
    return res.data?.responseMessage?.message;
};
// by yck
const AddEditAnalysis = async (param)=>{
    // const url = 'api/SoilProfile/AddEditAnalysis';
    console.log('lanxue details AddEditAnalysis',param);
    const url = '/api/SoilProfile/AddEditSoil';
    const requestData:IAddEditSoilRequestModel = JSON.parse(JSON.stringify(initAddEditSoilRequestModel));
    // for old submitData, maybe just one properties
    requestData.analysis.analysedby = param?.analysedby || '';
    requestData.analysis.contributor = param?.contributor || '';
    requestData.analysis.layerid = param?.layerid || 0;
    requestData.profile.profileid = param?.profileid || 0;
    requestData.analysis.propertyMeasurements = param?.propertyMeasurements || [];
    requestData.analysis.requestedby = param?.requestedby || '';
    requestData.analysis.uploadDate = param?.sampleDate || '';
    requestData.sample.sampleDate = param?.sampleDate || '';
    requestData.sample.sampleDepth = param?.sampleDepth || 0;
    requestData.sample.sampleEndDepth = param?.sampleEndDepth || 0;
    requestData.sample.sampleExternalRef = param?.sampleExternalRef || '';
    requestData.sample.sampleStatusID = param?.sampleStatusID || 0;
    requestData.sample.sampleid = param?.sampleid || 0;
    // for old obj
    // requestData.addEditFlag = param?.addEditFlag;
    requestData.addEditFlag = param.addEditFlag == 'add' ? 0 : 1;
    const res = await http.post<IAddEditSoilRequestModel,any>(
        url,
        requestData,
        ServerType.ServerNormal,
        true
    );
    // const res = await http.post(
    //     url,
    //     param,
    //     ServerType.ServerNormal,
    //     true
    // );
    return res.data;
};
// by yck
const deleteAnalysis = async (param)=>{
    // const url = 'api/SoilProfile/Deleteanalyses';
    console.log('lanxue delete deleteAnalysis',param);
    const url = '/api/SoilProfile/DeleteSoil';
    const requestData:IDeleteSoilRequestModel = JSON.parse(JSON.stringify(initDeleteSoilRequestModel));
    // const requestData:IDeleteSoilRequestModel = null;
    requestData.analysis.strAnalysesIDs = param?.strAnalysesIDs || '0';
    console.log('lanxue delete requestData',requestData);

    const res = await http.post<IDeleteSoilRequestModel,any>(url,requestData,ServerType.ServerNormal);

    return res?.data;
};

// by yck
const FetchanalysisDetail = async (param)=>{
    // const url = 'api/SoilAnalysis/FetchanalysisDetail';
    console.log('lanxue details',param);
    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.analysis.intSampleID = param?.sampleID || 0;
    // const res = await http.post(url,param);
    const res = await http.post<IGetSearchSoilRequestModel,any>(url,requestData,ServerType.ServerNormal);
    console.log('lanxue details requestData',requestData);
    return res.data?.responseMessage?.message;
};
//start by echo
const getSoilProperty = async (searchString:string) => {
    // const url = 'api/ReferenceData/GetSoilProperty?searchValue=' + searchString;
    const url = 'api/SoilAnalysis/GetSoilProperty?searchValue=' + searchString;
    const response = await http.get<
        IReferenceSoilPropertyRequestModel, AxiosResponse<ISoilSearchPropertyResModel>>(
            url,
            null,
            ServerType.ServerNormal
        );
    return response.data;
};
const getEstimationMethod = async (searchString: string) => {
    // const url = 'api/ReferenceData/GetEstimationMethod?searchValue=' + searchString;
    const url = 'api/SoilAnalysis/GetEstimationMethod?searchValue=' + searchString;
    const response = await http.get<
        IReferenceEstimationMethodRequestModel, AxiosResponse<any>>(
            url,
            null,
            ServerType.ServerNormal
        );
    return response.data;
};
const getExtReferenct = async (searchString: string) => {
    // const url = 'api/ReferenceData/GetExtReferenct?searchValue=' + searchString;
    const url = 'api/SoilAnalysis/GetExtReference?searchValue=' + searchString;
    const response = await http.get<
        IReferenceExtReferenctRequestModel, AxiosResponse<any>>(
            url,
            null,
            ServerType.ServerNormal
        );
    return response.data;
};
const getUserList = async (data: {
    searchText?: string
    pageIndex?: number
    pageSize?:number
    isGetAllUsers?: boolean
    isSortByNameDesc?:boolean
}) => {
    const url = 'api/User/GetUserList';
    const response = await http.post<
        IUserManagementSearchRequestModel, AxiosResponse<IUserManagementSearchModel[]>>(
            url,
            data,
            ServerType.ServerNormal
        );
    return response.data;
};
const deleteUsers = async (param) => {
    const url = 'api/User/SetInactiveUsers';
    const res = await http.post(
        url,
        param,
        ServerType.ServerNormal,
    );
    return res.data;
};
const addUsers = async (data: IUserManagementAddUsersRequestModel) => {
    const url = 'api/User/AddUser';
    const response = await http.post<
        IUserManagementAddUsersRequestModel, AxiosResponse<any>>(
            url,
            data,
            ServerType.ServerNormal,
        );
    return response.data;
};
const editUsers = async (data: IUserManagementeEditUsersRequestModel) => {
    const url = 'api/User/UpdateUser';
    const response = await http.post<
        IUserManagementeEditUsersRequestModel, AxiosResponse<any>>(
            url,
            data,
            ServerType.ServerNormal,
        );
    return response.data;
};

// by yck
const UploadTemplate = async (param)=>{
    const url = 'api/Template/UploadTemplate';
    // console.log(param.get('file'));
    const response = await http.post(
        url,
        param,
        ServerType.ServerNormal,
        false,
        true
    );
    return response;
};
const sendWelcomeEmail = async (data: IUserManagementeSendWelcomeEmailrRequestModel) => {
    const url = 'api/User/SendWelcomeEmail';
    const response = await http.post<
        IUserManagementeSendWelcomeEmailrRequestModel, AxiosResponse<any>>(
            url,
            data,
            ServerType.ServerNormal,
        );
    return response.data;
};
const updateUser = async (data: IUserManagementeUpdateUserRequestModel) => {
    const url = 'api/User/UpdateUser';
    const response = await http.post<
        IUserManagementeUpdateUserRequestModel, AxiosResponse<any>>(
            url,
            data,
            ServerType.ServerNormal,
        );
    return response.data;
};
//Echo:search user function in https://localhost:7052/
const searchUserInformation = async (searchText: string) => {
    const url = '/api/User/GetAzureUsersInfo';
    const response = await http.post<
        { searchText: string },
        AxiosResponse<any>
    >(url, { searchText }, ServerType.ServerNormal);
    return response.data;
};
//end by Echo
// by yck
export const GetPropertyList = async () => {
    const url = 'api/SoilAnalysis/GetPropertyList';
    const res = await http.post<null, AxiosResponse<GetPropertyListResponseModel[]>>(url,null,ServerType.ServerNormal);
    console.log(res);
    return res.data;
};


// by yck
export const GetAnalysesList = async (searchParam:string,sortCol,order,page, status) => {
    const data = {
        searchString:searchParam,
        sortCol:sortCol,
        order:order,
        pageIndex:1,
        pageSize:15*page,
        strStatus: status
    };
    // const url = 'api/SoilAnalysis/GetMySoilAnalyses';
    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.analysis.strSearch = searchParam;
    requestData.analysis.sortCol = sortCol || '';
    requestData.analysis.order = order || '';
    requestData.analysis.pageIndex = 1;
    requestData.analysis.pageSize = 15 * page;
    requestData.analysis.strStatus = status || '';
    requestData.isAnalysis = true;
    console.log('lanxue config requestData',requestData);

    const res = await http.post<IGetSearchSoilRequestModel,any>(url,requestData,ServerType.ServerNormal);
    // const res = await http.post(url,data,ServerType.ServerNormal);
    return res.data?.responseMessage?.message;
};
// by yck
export const getSoilPropertyMethods = async (param)=>{
    const url = 'api/SoilAnalysis/GetSoilPropertyMethods';
    const res = await http.post<getSoilPropertyMethodsType,AxiosResponse<GetSoilPropertyMethodsType[]>>(url,param,ServerType.ServerNormal);
    return res.data;
};
// by yck
const DownloadTemplate = async (param) => {
    const url = 'api/Template/DownloadTemplate';
    return http.downloadBlob(
        url,
        param,
        ServerType.ServerNormal
    );
};
// by yck
const downloadUserList = async (
    fileName: string,
    enumFileType: string,
    selectedUserIDs:string,
) => {
    const url = 'api/User/DownloadUserList';
    return http.downloadBlob(url, {fileName, enumFileType,selectedUserIDs },ServerType.ServerNormal);
};
// by yck
export const DLAnalyses = async (
    strProfileCode: string,
    strProfileName: string,
    enumFileType: string,
    listSampleIDs:any[],
    fileName:string
)=>{
    // const url = 'api/SoilAnalysis/DLAnalyses';
    // const url = 'api/SoilProfile/DownloadBriefProfiles';
    const url = 'api/SoilProfile/DownloadBriefProfiles';
    const res = await http.downloadBlob(url,{IsAnalysis:true,profileCodes:strProfileCode, strProfileName, enumFileType,listSampleIDs,fileName },
        ServerType.ServerNormal);
    return res;
};
// by yck
export const DLAnalysisDetail = async (data)=>{
    const url = 'api/SoilAnalysis/DLAnalysisDetail';
    const response = await http.downloadBlob(url, data,ServerType.ServerNormal);
    return response;
};
// by yck
export const GetAllTemplateList = async (data)=>{
    const url = '/api/Template/GetAllTemplateList';
    const response = await http.post(url, data,ServerType.ServerNormal);
    return response.data;
};
// by yck
export const GetSoilProfileToPerformed = async (data)=>{
    const url = 'api/Template/GetSoilProfileToPerformed';
    const response = await http.post(url, data,ServerType.ServerNormal);
    return response.data;
};
// by yck
export const GetPropertiesToPerformed = async (data)=>{
    const url = 'api/Template/GetPropertiesToPerformed';
    const response = await http.post(url, data,ServerType.ServerNormal);
    return response.data;
};
// by yck
export const DeleteTemplate = async (data)=>{
    const url = 'api/Template/DeleteTemplate';
    const response = await http.post(url, data,ServerType.ServerNormal);
    return response.data;
};
// by yck
export const AddNewTemplate = async (data)=>{
    const url = 'api/Template/AddNewTemplate';
    const response = await http.post(url, data,ServerType.ServerNormal,true);
    return response.data;
};
// by yck
export const GetTemplateDetailToView = async (data)=>{
    const url = 'api/Template/GetTemplateDetailToView';
    const response = await http.post(url, data,ServerType.ServerNormal);
    return response.data;
};

const getMenu = async () => {
    const url = '/api/User/GetMenu';
    const response = await http.get<any>(url, null, ServerType.ServerNormal);
    return response.data;
};

const downloadMethod = async ({
    downloadElement,
    window,
    fileName,
    selectedUserIDs
}) => {
    const url = '/api/SoilAnalysis/DownloadUserList';
    const response = await http.download(url, {selectedUserIDs});
    const blob = new Blob([response.data], {type: response.headers['content-type']});
    // let downloadElement = document.createElement('a');
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = fileName;
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(href);
};

const soilProfileGetRegion = async () => {
    const url = '/api/SoilSearch/GetRegions';
    const response = await http.post<null,AxiosResponse<ISoilRegionResModel[]>>(url,null,ServerType.ServerNormal);
    return response.data;
};

const soilProfileGetCountries = async (regionIDs: string) => {
    const url = '/api/SoilSearch/GetCountries';
    const response = await http.post<
    ISoilProfileGetCountriesReqModel,
    AxiosResponse<ISoilProfileGetCountriesResModel[]>>(url, { regionIDs },ServerType.ServerNormal);
    return response.data;
};

const soilProfileGetExistSourceLink = async () => {
    const url = '/api/SoilProfile/GetExtSourceLink';
    const response = await http.post<null, AxiosResponse<ISoilProfilesExtSourceLinkResModel[]>>(
        url,
        null,
        ServerType.ServerNormal
    );
    return response.data;
};

const soilProfileGetExtObjects = async (data: { extSystem: string }) => {
    const url = '/api/SoilProfile/GetExtObjects';
    const response = await http.post<{ extSystem: string }, AxiosResponse<ISoilProfileExtObjectsResModel[]>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response.data;
};

const soilProfileAddNewProfile = async (data: ISoilProfileAddProfileReqModel) => {
    // const url = '/api/SoilProfile/AddEditProfile';
    console.log('lanxue detail soilProfileAddNewProfile',data);
    const url = '/api/SoilProfile/AddEditSoil';
    const requestData:IAddEditSoilRequestModel = JSON.parse(JSON.stringify(initAddEditSoilRequestModel));
    requestData.addEditFlag = data.addEditFlag == 'add' ? 0 : 1; // 老的接口传 add 或 edit，Kevin 改成了 0 ， 1 来判断需要再次确认
    requestData.profile.adminName1 = data.adminname1 || '';
    requestData.profile.countryCode = data.countrycode || '';
    requestData.profile.extObject = data.extObject || '';
    requestData.profile.extrefID = data.extrefID || 0;
    requestData.profile.fieldType = data.fieldType || 0;
    requestData.profile.isStandard = data.isStandard || true;
    requestData.profile.lat = data.lat || 0;
    requestData.profile.layerDetails = [...data.layerDetails] || requestData.profile.layerDetails;
    requestData.profile.lng = data.lng || 0;
    requestData.profile.placeName = data.placeName || '';
    requestData.profile.profileDesc = data.profileDesc || '';
    requestData.profile.profileName = data.profileName || '';
    requestData.profile.profileid = data.profileid || 0;
    requestData.profile.publisher = data.publisher || '';


    const response = await http.post<IAddEditSoilRequestModel,
    AxiosResponse<any>
    >(
        url,
        requestData,
        ServerType.ServerNormal,
        true
    );
    // const response = await http.post<ISoilProfileAddProfileReqModel,
    // AxiosResponse<ISoilProfileAddProfileReqModel>>(
    //     url,
    //     data,
    //     ServerType.ServerNormal,
    //     true
    // );
    return response.data;
};

const soilProfileGetFieldType = async () => {
    const url = '/api/SoilProfile/GetFieldTypes';
    const response = await http.post<null, AxiosResponse<ISoilProfileFieldTypeResModel[]>>(
        url,
        null,
        ServerType.ServerNormal
    );
    return response.data;
};

const soilProfileGetPlaceNameByLatLong = async (lat: number, lng: number) => {
    const url = '/api/SoilSearch/GetLocationByLatLng';
    const response = await http.post<{ lat: number, lng: number }, AxiosResponse<ISoilProfilePlaceNameResModel>>(
        url,
        { lat, lng },
        ServerType.ServerNormal
    );
    return response.data;
};

const soilProfileGetPlaceNameByString = async (strSearchText: string) => {
    const url = '/api/SoilSearch/GetLocationByPlaceName';
    const response = await http.post<{ strSearchText }, AxiosResponse<ISoilProfilePlaceNameResModel>>(
        url,
        { strSearchText },
        ServerType.ServerNormal
    );
    return response.data;
};

const soilProfileGetSoilProfileDetail = async (profileCode: string) => {
    // const url = '/api/SoilAnalysis/GetSoilProfileDetail';
    const url = '/api/SoilProfile/GetSearchSoil';
    // const requestData:IGetSearchSoilRequestModel = {...initGetSearchSoilRequestModel};
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.profile.profileCode = profileCode;


    const response = await http.post<
        IGetSearchSoilRequestModel,
        AxiosResponse<any>
    >(
        url,
        requestData,
        ServerType.ServerNormal
    );
    return response.data?.responseMessage?.message;
};

const soilProfileGetLayersDetail = async (profileID: number) => {
    // const url = '/api/SoilAnalysis/GetSoilLayers';
    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.profile.profileID = profileID;

    const response = await http.post<
    IGetSearchSoilRequestModel,
    // AxiosResponse<ISoilProfileGetLayersDetailResModel[]>
    any
    >(
        url,
        requestData,
        ServerType.ServerNormal
    );
    return response.data?.responseMessage?.message;
};

const soilProfileDeleteTargetProfile = async (strProfilesIDs: string) => {
    // const url = '/api/SoilProfile/DeleteProfiles';
    const url = '/api/SoilProfile/DeleteSoil';
    const requestData:IDeleteSoilRequestModel = JSON.parse(JSON.stringify(initDeleteSoilRequestModel));
    requestData.profile.strProfileIDs = strProfilesIDs || '';

    const response = await http.post<IDeleteSoilRequestModel, AxiosResponse<any>>(
        url,
        requestData,
        ServerType.ServerNormal);

    // const response = await http.post<{strProfilesIDs: string}, AxiosResponse<boolean | string[]>>(
    //     url,
    //     {strProfilesIDs},
    //     ServerType.ServerNormal);
    return response.data;
};


const soilProfileGetMethodList = async () => {
    const url = '/api/SoilAnalysis/GetSoilPropertyMethods';
    const response = await http.post<
    {propertyName: string, unit: string},
    AxiosResponse<ISoilProfileMethodsResModel[]>>(
        url,
        {propertyName: 'Thickness', unit: 'cm'},
        ServerType.ServerNormal
    );
    return response.data;
};

const soilProfileGetProfilesCount = async () => {
    const url = '/api/SoilProfile/GetProfilesCount';
    const response = await http.post<null, AxiosResponse<string>>(
        url,
        null,
        ServerType.ServerNormal
    );
    return response.data;
};

const soilProfileGetMyProfilesCount = async () => {
    const url = '/api/SoilProfile/GetMyProfilesCount';
    const response = await http.post<null, AxiosResponse<string>>(
        url,
        null,
        ServerType.ServerNormal
    );
    return response.data;
};

const soilProfileGetAllProfilesCount = async () => {
    const url = '/api/SoilProfile/GetProfilesCount';
    const response = await http.post<null, AxiosResponse<string>>(
        url,
        null,
        ServerType.ServerNormal
    );
    return response.data;
};


const soilProfileDownloadProfile = async ({
    listProfilesIDs,
    enumFileType,
    fileName
}) => {
    const url = '/api/SoilProfile/DLProfiles';
    return http.downloadBlob(url, {listProfilesIDs, enumFileType, fileName },ServerType.ServerNormal);
};

const soilProfileDownLoadProfileDetail = async (
    strProfileCode: string,
    strProfileName: string,
    enumFileType: string,
    fileName: string,
    intLayerID?: number[],
    intSampleID?: number[],
    strPropertiesIDs?: string
) => {
    const url = '/api/SoilProfile/DLProfileDetail';
    return http.downloadBlob(url, {
        strProfileCode,
        strProfileName,
        intLayerID,
        intSampleID,
        enumFileType,
        fileName,
        strPropertiesIDs
    },ServerType.ServerNormal);
};

const userManagementGetCurrentUserInfo = async () => {
    const url = '/api/User/GetCurrentUserInfo';
    const response = await http.get<null, AxiosResponse<IManagementUserInfoResModel>>(url, null, ServerType.ServerNormal);
    return response.data;
};

const soilProfileGetValiadateStatus = async () => {
    const url = '/api/SoilProfile/GetValidationStatuses';
    const response = await http.post<null, AxiosResponse<ISoilProfileValidateStatusResModel[]>>(url,null,ServerType.ServerNormal);
    return response.data;
};

const soilSearchGetAllProfilePoint = async () => {
    const url = '/api/SoilProfile/GetAllProfilePoints';
    const response = await http.get<null, AxiosResponse<ISoilSearchProfilePointResModel[]>>(url,null,ServerType.ServerNormal);
    return response.data;
};

const soilSearchGetRadiusSetting = async () => {
    const url = '/api/SoilSearch/GetSoilSearchRadiusSetting';
    const response = await http.get<null, AxiosResponse<{ defaultValue: number, maxValue: number}>>(url,null,ServerType.ServerNormal);
    return response.data;
};

const soilSearchGetPointsByCoordinatesRadiusProperty = async (data: ISoilSearchGetPointByMultiperParamReqModel) => {
    // const url = '/api/SoilAnalysis/SearchProfilesByCoordinates';
    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.coordinate.strSearchCoordinates = data.coordinates;
    requestData.coordinate.searchRadius = data.radius;
    requestData.coordinate.propertiesIDs = data.propertiesIDs;

    // const response = await http.post<ISoilSearchGetPointByMultiperParamReqModel, AxiosResponse<ISoilSearchProfilePointResModel[]>>(
    //     url,
    //     data
    // );
    const response = await http.post<IGetSearchSoilRequestModel, AxiosResponse<any>>(
        url,
        requestData,
        ServerType.ServerNormal
    );
    return response.data?.soilProfilePointModels;
};

const soilProfileCheckThicknessRange = async (data:ISoilProfileCheckThicknessParamReqModel) => {
    const url = '/api/SoilAnalysis/CheckThickness';
    const res = await http.post<ISoilProfileCheckThicknessParamReqModel, AxiosResponse<string>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return res.data;
};

const soilSearchSoilProfileTableView = async (data: ISoilSearchTableViewReqModel) => {
    // const url = '/api/SoilAnalysis/SearchProfileByCoordinatesForTableView';
    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.isForTableView = true;
    requestData.coordinate.coordinates = data.coordinateList;
    requestData.coordinate.searchRadius = data.searchRadius;
    requestData.coordinate.propertiesIDs = data.propertiesIDs;
    requestData.coordinate.isSplitByCountry = data.isSplitByCountry;
    const res = await http.post<IGetSearchSoilRequestModel, AxiosResponse<any>>(
        url,
        requestData,
        ServerType.ServerNormal,
        true
    );
    // const res = await http.post<ISoilSearchTableViewReqModel, AxiosResponse<ISoilSearchTableViewResModel[]>>(
    //     url,
    //     data,
    //     ServerType.ServerPublic,
    //     true
    // );
    return res.data?.briefProfileModels;
};

export const soilSearchDownloadBriefProfiles = async (
    profileCodes: string,
    propertiesIDs: string,
    fileName: string,
    enumFileType: string,
) => {
    // const url = 'api/SoilAnalysis/DLAnalyses';
    const url = 'api/SoilProfile/DownloadBriefProfiles';
    const res = await http.downloadBlob(url,{
        IsAnalysis:false,
        profileCodes:profileCodes,
        propertiesIDs,
        fileName,
        enumFileType
    },ServerType.ServerNormal);
    return res;
};

const getWeatherPropertiesData = async () => {
    const url = '/api/WeatherStation/GetWeatherPropertiesData';
    const res = await http.post<null, AxiosResponse<IWeatherStationSupplierPropertiesResModel>>(
        url,
        null,
        ServerType.ServerNormal,
        true
    );
    return res.data;
};

const getPoliticalAreaList = async () => {
    const url = '/api/WeatherStation/GetPoliticalAreaList';
    const res = await http.post<null, AxiosResponse<IWeatherStationAdminAreaResModel[]>>(
        url,
        null,
        ServerType.ServerNormal,
        true
    );
    return res.data;
};

const soilSearchGetAdministrativeArea = async (parentID: string, isGetRegion: boolean) => {
    const url = '/api/SoilSearch/GetGlobalAdministrativeAreas';
    const res = await http.post<{ parentID: string, isGetRegion: boolean }, AxiosResponse<ISoilSearchAdministrativeAreaResModel[]>>(
        url,
        { parentID, isGetRegion },
        ServerType.ServerNormal
    );
    return res.data;
};

const soilSearchGetProfileTableViewDataByAreas = async (
    areaIDs: string,
    propertiesIDs: string,
    isSplitByCountry: boolean
) => {
    // const url = '/api/SoilAnalysis/SearchProfileByAreasForTableView';
    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.isForTableView = true;
    requestData.coordinate.areaIDs = areaIDs;
    requestData.coordinate.propertiesIDs = propertiesIDs;
    requestData.coordinate.isSplitByCountry = isSplitByCountry;
    // const res = await http.post<{
    //     areaIDs: string,
    //     propertiesIDs: string,
    //     isSplitByCountry: boolean
    // }, AxiosResponse<ISoilSearchTableViewResModel[]>>(
    //     url,
    //     { areaIDs, propertiesIDs, isSplitByCountry },
    //     ServerType.ServerPublic,
    //     true
    // );
    const res = await http.post<
        IGetSearchSoilRequestModel
    , AxiosResponse<any>>(
        url,
        requestData,
        ServerType.ServerNormal,
        true
    );
    return res.data?.briefProfileModels;
};


const soilSearchGetProfilePointsByAreaIds = async (data: ISoilSearchGetProfilePointRequestModel) => {
    // const url = '/api/SoilAnalysis/SearchProfilesByAreas';
    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.coordinate.areaIDs = data.areaIDs;
    requestData.coordinate.propertiesIDs = data.propertiesIDs;
    // const res = await http.post<
    //     ISoilSearchGetProfilePointRequestModel,
    //     AxiosResponse<ISoilSearchProfilePointResModel[]>>(
    //         url, data
    //     );
    const res = await http.post<
        IGetSearchSoilRequestModel,
        AxiosResponse<any>>(
            url,
            requestData,
            ServerType.ServerNormal
        );
    return res.data?.soilProfilePointModels;
};

const soilSearchGetProfilePointByPolygonOrCircle = async (
    data: ISoilSearchGetProfilePointByPolygonReqModel) => {
    // const url = '/api/SoilAnalysis/SearchProfilesByPolygon';
    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.coordinate.polygon = data.polygon;
    requestData.coordinate.propertiesIDs = data.propertiesIDs;

    // const res = await http.post<ISoilSearchGetProfilePointByPolygonReqModel,
    //     AxiosResponse<ISoilSearchProfilePointResModel[]>
    // >(url, data);

    const res = await http.post<IGetSearchSoilRequestModel,
        AxiosResponse<any>
    >(url, requestData,ServerType.ServerNormal);
    return res.data?.soilProfilePointModels;
};

const soilSearchGetProfileTableViewByPolygonOrCircle = async (
    data: ISoilSearchGetProfieTableViewByPolygonReqModel) => {
    // const url = '/api/SoilAnalysis/SearchProfileByPolygonForTableView';
    const url = '/api/SoilProfile/GetSearchSoil';
    const requestData:IGetSearchSoilRequestModel = JSON.parse(JSON.stringify(initGetSearchSoilRequestModel));
    requestData.isForTableView = true;
    requestData.coordinate.polygon = data.polygon;
    requestData.coordinate.propertiesIDs = data.propertiesIDs;
    requestData.coordinate.isSplitByCountry = data.isSplitByCountry;

    const res = await http.post<IGetSearchSoilRequestModel,
        AxiosResponse<any>
    >(
        url,
        requestData,
        ServerType.ServerNormal,
        true
    );
    // const res = await http.post<ISoilSearchGetProfilePointByPolygonReqModel,
    //     AxiosResponse<ISoilSearchTableViewResModel[]>
    // >(
    //     url,
    //     data,
    //     ServerType.ServerPublic,
    //     true
    // );
    return res.data?.briefProfileModels;
};

const sendFeedBack = async (data: IFeedbackModel) => {
    const url = 'api/Feedback/SendFeedback';
    console.log('config data: ',data);
    const response = await http.post<
        IFeedbackModel, AxiosResponse<any>>(
            url,
            data,
            ServerType.ServerNormal,
            false,
            true
        );
    return response.data;
};

const soilGetSignUrl = async () => {
    const url = '/api/Home/GetSignInUrl';
    const response = await http.get<null, AxiosResponse<ISignInUrlResModel>>(
        url,
        null,
        ServerType.ServerNormal
    );
    return response.data;
};

const soilGetUserToken = async (data: ITokenReqModel) => {
    const url = '/api/Home/GetToken';
    const response = await http.post<ITokenReqModel, AxiosResponse<ITokenResModel>>(
        url,
        data,
        ServerType.ServerNormal
    );
    return response;
};

const soilSelfGetService = async () => {
    const url = '/api/Home/GetSelfServicePortalUrl';
    const repsonse = await http.post<null, AxiosResponse<string>>(
        url,
        null,
        ServerType.ServerNormal
    );
    return repsonse.data;
};

const weatherGetWeatherStationDetail = async (data: IWeatherStationReqModel) => {
    const url = '/api/WeatherStation/GetStations';
    const response = await http.post<IWeatherStationReqModel, AxiosResponse<IWeatherStationResModel>>(url, data, ServerType.ServerNormal, true);
    return response;
};

const portalProceedModuleSelect = async (module : 'self-service portal' | 'soil analysis' | 'weather station query' | 'weather historictal map' | 'weather forecast map'|'agri alert') => {
    const url = '/api/Home/ProceedModuleSelectFromPortal';
    const response = await http.post<{module: string}, AxiosResponse<null>>(url, {module}, ServerType.ServerNormal);
    return response.data;
};

const weatherGetChartData = async (data: IWeatherChardDataReqModel) => {
    const url = '/api/WeatherStation/GetHistoricalDataAPI';
    const response = await http.post<IWeatherChardDataReqModel, AxiosResponse<IWeatherChartDataResModel[]>>(url, data, ServerType.ServerNormal, true);
    return response.data;
};


// SECTION: save =========================================================================
const weatherGetSavedQueries = async () => {
    const url = '/api/WeatherStation/GetSavedQueries';
    const response = await http.post<null, AxiosResponse<IWeatherStationReqModel[]>>(url, null, ServerType.ServerNormal);
    return response.data;
};

const weatherSaveQuery = async (data: IWeatherSaveQueryReqModel) => {
    const url = '/api/WeatherStation/SaveQuery';
    const response = await http.post<IWeatherSaveQueryReqModel, AxiosResponse<number>>(url, data, ServerType.ServerNormal, true);
    return response.data;
};

const weatherCheckQueryNameIsExist = async (data: string) => {
    const url = '/api/WeatherStation/CheckQueryNameIsExists';
    const response = await http.post<{ queryName: string }, AxiosResponse<boolean>>(url, { queryName: data }, ServerType.ServerNormal);
    return response.data;
};

const weatherDownloadXls = async (data: IWeatherStationReqModel, enumFileType: string, fileName: string) => {
    const url = '/api/WeatherStation/Download';
    const response = await http.downloadBlob(url, { ...data, enumFileType, fileName }, ServerType.ServerNormal, true);
    return response;
};

const weatherGetRecentQueries = async () => {
    const url = '/api/WeatherStation/GetRecentQueries';
    const response = await http.post<{days: number, limit: number}, AxiosResponse<IWeatherStationReqModel[]>>(url, null, ServerType.ServerNormal);
    return response.data;
};

const weatherGetHierarchy = async () => {
    const url = '/api/WeatherStation/GetHierarchies';
    const response = await http.post<null, AxiosResponse<IWeatherHierarchiesResModel>>(url, null, ServerType.ServerNormal);
    return response.data;
};

const weatherRemoveQuery = async (data: string) => {
    const url = '/api/WeatherStation/DeleteQuery';
    const response = await http.post<{queryId: string}, AxiosResponse<boolean>>(url, { queryId: data }, ServerType.ServerNormal);
    return response.data;
};

const weatherGetQuery = async (queryGuid: string) => {
    const url = '/api/WeatherStation/GetQuery';
    const response = await http.post<{ queryId?: string, queryGuid?: string }, AxiosResponse<IWeatherStationReqModel>>(url, { queryGuid }, ServerType.ServerNormal);
    return response.data;
};

const downloadWithStation = async (data: IWeatherChardDataReqModel, enumFileType: string, fileName: string) => {
    const url = '/api/WeatherStation/DownloadWithStationDataAPI';
    const response = await http.downloadBlob(url, { ...data, enumFileType, fileName }, ServerType.ServerNormal, true);
    return response;
};

const weatherGetStations = async (data: { startDate: string, endDate: string, supplier: string }) => {
    const url = '/api/WeatherStation/GetStationIDs';
    const response = await http.post<{startDate: string, endDate: string, supplier: string}, AxiosResponse<IWeatherStationInfoResModel[]>>(url, data, ServerType.ServerNormal);
    return response.data;
};

const weatherGetJustStations = async (data: { startDate: string, endDate: string, supplier: string }) => {
    const url = '/api/WeatherStation/GetStationsGeo';
    const response = await http.post<{startDate: string, endDate: string, supplier: string}, AxiosResponse<IWeatherStationInfoResModel[]>>(url, data, ServerType.ServerNormal);
    return response.data;
};

const getWeatherStationVariables = async (data: { startDate: string, endDate: string, supplier: string, station: string }) => {
    const url = 'api/WeatherStation/GetStationsVariables';
    const response = await http.post<{startDate: string, endDate: string, supplier: string, station: string}, AxiosResponse<IWeatherStationInfoResModel>>(url, data, ServerType.ServerNormal);
    return response.data;
};

const getNewHierarchies = async (data: IHierarchyDeatails[])=>{
    const url = '/api/WeatherStation/GetNewHierarchies';
    const response = await http.post<IHierarchyDeatails[], AxiosResponse<IHierarchy[]>>(url, data, ServerType.ServerNormal, true);
    return response.data;
};

const soilSaveQuery = async (data: ISoilSaveQueryReqModel) => {
    const url = '/api/SoilQuery/SaveQuery';
    const response = await http.post<ISoilSaveQueryReqModel, AxiosResponse<number>>(url, data, ServerType.ServerNormal, true);
    return response;
};

const soilGetSavedQueries = async () => {
    const url = '/api/SoilQuery/GetSavedQueries';
    const response = await http.post<null, AxiosResponse<ISoilQueriesModel[]>>(url, null, ServerType.ServerNormal, true);
    return response;
};

const soilCheckQueryNameIsExist = async (queryName: string) => {
    const url = '/api/SoilQuery/CheckQueryNameIsExists';
    const response = await http.post<{queryName: string}, AxiosResponse<boolean>>(url, { queryName }, ServerType.ServerNormal, false);
    return response;
};

const soilDeleteQuery = async (queryId: number) => {
    const url = '/api/SoilQuery/DeleteQuery';
    const response = await http.post<{queryId:number}, AxiosResponse<ISoilDeleteQuery>>(url, { queryId }, ServerType.ServerNormal, false);
    return response;
};

const soilGetQuery = async (queryId?: number, queryGuid?: string) => {
    const url = '/api/SoilQuery/GetQuery';
    const response = await http.post<{
        queryId: number
        queryGuid: string
    }, AxiosResponse<ISoilQueriesModel>>(url, {
        queryGuid,
        queryId
    }, ServerType.ServerNormal, false);
    return response;
};

const soilGetRecentQueries = async () => {
    const url = '/api/SoilQuery/GetRecentQueries';
    const response = await http.post<null, AxiosResponse<ISoilQueriesModel[]>>(url, null, ServerType.ServerNormal, false);
    return response;
};

const soilGetAuthenticate = async () => {
    const url = 'api/User/GetCurrentUserInfo';
    const response = await http.get<null, AxiosResponse<{ userIsActive: boolean }>>(url, null, ServerType.ServerNormal);
    return response;
};
const agriAlertGetAuthenticate = async (module:string) => {
    const url = 'api/User/GetCurrentUserInfo?module=' + module;
    const response = await http.get<null, AxiosResponse<IManagementUserInfoResModel>>(url, null, ServerType.ServerNormal);
    return response.data;
};


// please export your request here
export {
    fetchSoilProfileList,
    getSoilProperty,
    getEstimationMethod,
    getExtReferenct,
    getToken,
    getManagerUserToken,
    getReaderUserToken,
    getUserList,
    downloadUserList,
    getMenu,
    downloadMethod,
    soilProfileGetRegion,
    soilProfileGetCountries,
    soilProfileGetExistSourceLink,
    soilProfileGetExtObjects,
    soilProfileAddNewProfile,
    getSoilLayer,
    AddEditAnalysis,
    deleteAnalysis,
    soilProfileGetFieldType,
    soilProfileGetPlaceNameByLatLong,
    FetchanalysisDetail,
    soilProfileGetSoilProfileDetail,
    soilProfileGetLayersDetail,
    soilProfileDeleteTargetProfile,
    soilProfileGetMethodList,
    deleteUsers,
    soilProfileGetProfilesCount,
    soilProfileDownloadProfile,
    searchUserInformation,
    addUsers,
    editUsers,
    sendWelcomeEmail,
    updateUser,
    soilProfileGetPlaceNameByString,
    soilProfileDownLoadProfileDetail,
    userManagementGetCurrentUserInfo,
    DownloadTemplate,
    UploadTemplate,
    soilProfileGetValiadateStatus,
    soilSearchGetAllProfilePoint,
    soilSearchGetRadiusSetting,
    soilProfileGetMyProfilesCount,
    soilSearchGetPointsByCoordinatesRadiusProperty,
    soilProfileGetMySoilProfileList,
    soilProfileGetAllProfilesCount,
    soilProfileCheckThicknessRange,
    soilSearchSoilProfileTableView,
    getWeatherPropertiesData,
    getPoliticalAreaList,
    soilSearchGetAdministrativeArea,
    soilSearchGetProfileTableViewDataByAreas,
    soilSearchGetProfilePointsByAreaIds,
    soilSearchGetProfilePointByPolygonOrCircle,
    soilSearchGetProfileTableViewByPolygonOrCircle,
    sendFeedBack,
    soilGetSignUrl,
    soilGetUserToken,
    soilSelfGetService,
    weatherGetWeatherStationDetail,
    portalProceedModuleSelect,
    getNewHierarchies,
    weatherGetChartData,
    weatherGetSavedQueries,
    weatherSaveQuery,
    weatherCheckQueryNameIsExist,
    weatherDownloadXls,
    weatherGetRecentQueries,
    weatherGetHierarchy,
    weatherRemoveQuery,
    weatherGetQuery,
    downloadWithStation,
    weatherGetStations,
    soilSaveQuery,
    soilGetSavedQueries,
    soilCheckQueryNameIsExist,
    soilDeleteQuery,
    soilGetQuery,
    soilGetRecentQueries,
    soilGetAuthenticate,
    weatherGetJustStations,
    getWeatherStationVariables,
    agriAlertGetAuthenticate
};

